{
  "account": {
    "title": "Mon compte",
    "list": {
      "title": "Comptes",
      "description": "Liste des facture liées au compte"
    },
    "form": {
      "name": {
        "title": "Nom",
        "description": "Nom du compte"
      },
      "password": {
        "title": "Mot de passe",
        "description": "Définissez un nouveau mot de passe pour votre compte, laissez le champ vide pour conserver le mot de passe actuel."
      },
      "emailPreferences": {
        "title": "Preferences Email",
        "description": "Selection des types de notification mail"
      }
    },
    "billing": "Détail facturation",
    "subscriptions": "Souscriptions",
    "manageSubscription": "Gérer les souscriptions",
    "popup": {
      "downgrade": "Êtes-vous sûr de rétrograder ? Ce sera effectiv immédiatement.<br/>Veuillez noter que vous ne pourrez pas bénéficier d'une remise pour la durée restante du cycle de facturation en cours.<br/>Le prix du nouveau forfait sera appliqué au prochain cycle de facturation.",
      "default": "Êtes-vous sûr de vouloir changer de forfait ?",
      "cancel": "Etes-vous sûr d'annuler votre abonnement ?<br/> Votre site Web continuera à être traduit jusqu'à la fin de votre période d'abonnement en cours. Après cela, la traduction sera désactivée.<br/> Veuillez noter que vous ne serez pas éligible à une remise pour la période non utilisée.",
      "resume": "Êtes-vous sûr de vouloir reprendre votre abonnement ?"
    }
  },
  "ai_translation": {
    "header": "Traduction IA",
    "plan": {
      "header": "Tarifs de traduction par IA",
      "used": "Vous avez utilisé {words_used} / {words_allowed} mots traduits dans vos crédits IA.",
      "remaining": "Crédits IA disponibles :",
      "words": "mots",
      "add_more_credits": "Ajouter plus de crédits d'IA",
      "details": {
        "idiomatic_expressions": "Expressions idiomatiques et techniques",
        "background_translation": "Traductions en arrière-plan",
        "page_context": "Contexte de la page et du site Web pour la traduction",
        "perfect_quality": "Qualité parfaite, prix abordable",
        "no_recurring": "Pas de paiement récurrent, quota prépayé",
        "save_40": "Économisez 40 % par rapport au forfait à 20 $",
        "save_50": "Économisez 50 % par rapport au forfait à 20 $",
        "best_website": "Site Web nécessitant une qualité de traduction parfaite"
      },
      "quota": "{estimated_words} mots ~ {estimated_pages} pages"
    },
    "settings": {
      "banner": {
        "title": "Traduction par IA Linguise",
        "intro": "Linguise est heureux de dévoiler Linguise AI Translation, une nouvelle fonctionnalité premium exploitant les modèles AI LLM (les modèles Llama les plus récents, optimisés pour les tâches de traduction). Conçue pour les sites web exigeant une précision irréprochable, elle prend en compte le contexte de la page et de l'ensemble du site pour des résultats inégalés. Offrez à vos clients une qualité de traduction optimale, garantissant une traduction parfaite dans toutes les langues.",
        "button": "Mettre à niveau maintenant"
      },
      "alert": {
        "description": "Cette fonctionnalité n'est pas incluse dans votre forfait actuel et nécessite un achat séparé. Activez ce module pour accéder à toutes les options ci-dessous."
      },
      "languages": {
        "title": "Appliquer la traduction de l'IA aux langues",
        "description": "Sélectionnez la langue spécifique dans laquelle vous souhaitez que la traduction IA s'applique"
      },
      "button": {
        "save": "Enregistrer les paramètres"
      },
      "form": {
        "rule_application": {
          "description": "Appliquer la traduction IA sur du contenu statique ou dynamique ou les deux",
          "title": "Appliquer au contenu",
          "all": "Tout le contenu",
          "static": "Contenu statique",
          "dynamic": "Contenu dynamique"
        },
        "website_topic": {
          "title": "Thème du site Web",
          "placeholder": "Restaurant de sushis...",
          "description": "Définissez le thème de votre site web pour une meilleure qualité de traduction (ex. Légal, restaurant de sushi, Eshop de pièces détachées vélo…).\nVeuillez saisir le thème du site web en anglais."
        },
        "apply_to_urls": {
          "title": "Appliquer aux URL",
          "description": "Sélectionnez les URL spécifiques auxquelles vous souhaitez que la traduction IA s'applique",
          "all_urls": "Toutes les URL",
          "selected_urls": "URL sélectionnées",
          "label": "URL à laquelle postuler",
          "placeholder": "URL à laquelle postuler",
          "wildcard": "Caractère générique",
          "regex": "Expression régulière",
          "add": "Ajouter un nouveau",
          "expression": "Type d'expression"
        },
        "apply_languages": {
          "title": "Appliquer aux langues",
          "description": "Sélectionnez la langue spécifique dans laquelle vous souhaitez que la traduction IA s'applique",
          "all_languages": "Toutes les langues",
          "selected_languages": "Langues sélectionnées",
          "placeholder": "Sélectionnez les langues...",
          "feedback": "Vous devez choisir une langue"
        },
        "enable_mode": {
          "title": "ACTIVER LA TRADUCTION IA",
          "description": "Choisissez comment vous souhaitez que la traduction IA soit activée.\nSeules les règles suivantes s'appliqueront.\nL'éditeur en direct permettra uniquement d'activer la traduction page par page à partir de la vue de l'éditeur en direct.\nLes règles et l'éditeur en direct utiliseront les deux fonctionnalités.",
          "disabled": "Désactivé",
          "rules": "Règles uniquement",
          "live_editor": "Éditeur en direct uniquement",
          "all": "Règles et éditeur en direct"
        },
        "formality": {
          "title": "Formalité",
          "description": "Précisez le degré de formalité des traductions, potentiellement important pour le public et le contexte.\n\"Neutre\" vise à préserver la formalité du contenu original.\n\"Formel\" est réservé aux contenus professionnels, commerciaux ou juridiques (par exemple, en utilisant des pronoms formels comme \"usted\" en espagnol).\n\"Informel\" est réservé aux contenus informels et conversationnels (par exemple, en utilisant \"tú\" en espagnol).",
          "neutral": "Neutre",
          "formal": "Officiel",
          "informal": "Informel"
        },
        "sentence_structure": {
          "classic": "Classique",
          "short": "Des phrases courtes et percutantes",
          "detailed": "Phrases détaillées et explicatives",
          "title": "Structure de la phrase",
          "description": "Définissez la préférence de style d’écriture."
        },
        "content_purpose": {
          "marketing": "Marketing/promotionnel (ton persuasif et engageant)",
          "technical": "Technique/pédagogique (clair, précis, orienté vers l'action)",
          "support": "Support client (empathique, serviable, rassurant)",
          "legal": "Légal/conformité (précis, formel, sans ambiguïté)",
          "educational": "Éducatif (clair, structuré, accessible)",
          "title": "Objectif du contenu",
          "description": "Définir l’objectif fonctionnel du contenu traduit.",
          "other_placeholder": "Décrivez le but...",
          "other": "Autre (en anglais)"
        },
        "target_audience": {
          "title": "Public cible",
          "description": "Spécification du public visé par le contenu traduit (en anglais).",
          "placeholder": "par exemple, des parents hispanophones, des responsables de la protection des données de l'UE"
        },
        "advanced": {
          "title": "Instructions d'IA avancées",
          "description": "Instructions d'IA avancées"
        },
        "override_default_translations": {
          "title": "Remplacer la traduction par défaut",
          "description": "Si cette option est activée (OUI), le contenu sera forcé d'être traduit par IA (Linguise AI) même s'il a déjà été traduit par la traduction IA du cloud (modèle de traduction par défaut)."
        },
        "force_replace_before": {
          "title": "Forcer la retraduction par IA",
          "description": "Retraduisez avec l’IA tout contenu dont la traduction par IA a été effectuée avant la date sélectionnée, par exemple avec un ancien modèle. La retraduction aura lieu lors de la prochaine visite des pages concernées, selon les règles, et utilisera vos crédits IA.",
          "before_date": "Avant une date"
        },
        "model": {
          "current": "Actuel",
          "title": "Modèle",
          "description": "Sélectionnez le modèle de traduction LLM que vous souhaitez utiliser",
          "load_error": "Impossible de charger les modèles disponibles. Veuillez réessayer plus tard.",
          "thinking_warning": "Ce modèle utilise un niveau élevé de raisonnement (\"réflexion\") et consommera considérablement plus de tokens par traduction."
        },
        "override_manual_and_selected": {
          "no_default": "Non (par défaut)",
          "title": "Remplacer les traductions manuelles et sélectionnées",
          "description": "Par défaut, une traduction que vous avez modifiée manuellement reste toujours affichée sur votre site, même après la génération d'une traduction améliorée par l'IA. Choisissez OUI pour afficher à la place la traduction améliorée par l'IA. Vos traductions manuelles sont conservées et vous pouvez revenir en arrière à tout moment. Cela s'applique également lorsque vous retraduisez les pages pour obtenir de nouvelles traductions ; la plus récente sera automatiquement utilisée."
        }
      },
      "message": {
        "save_success": "À partir du contenu actuel déjà traduit, le nombre de pages qui seraient améliorées avec la traduction IA est d'environ {{ai_affected_urls}}.",
        "save_success_only": "Paramètres enregistrés avec succès."
      }
    },
    "pricing": {
      "plan": {
        "title": "Commander un quota de traduction d'IA",
        "buy_button": "ACHETER UN PACK DE TRADUCTION IA"
      },
      "modal": {
        "title": "Confirmer le changement de plan",
        "description": "Êtes-vous sûr de vouloir modifier votre plan de traduction AI ?",
        "button_cancel": "Annuler",
        "button_confirm": "Confirmer",
        "loading": "S'il vous plaît, attendez...",
        "amount": "Montant",
        "credit": "Crédit",
        "total_due": "Total dû"
      },
      "comparison": {
        "title": "Traduction Google Cloud AI vs traduction Linguise AI",
        "list": {
          "0": {
            "google": "Traductions rapides et fiables",
            "linguise": "Gérer les expressions idiomatiques et techniques"
          },
          "1": {
            "google": "Traductions instantanées de toutes les pages du site Web",
            "linguise": "Génération des traductions en arrière-plan"
          },
          "2": {
            "google": "Meilleure qualité, prix bas",
            "linguise": "Qualité parfaite, prix abordable"
          },
          "3": {
            "google": "Idéal pour les grands sites Web ou les petits budgets",
            "linguise": "Idéal pour les sites Web nécessitant une qualité de traduction parfaite"
          },
          "4": {
            "google": "Contexte de la page pour la traduction",
            "linguise": "Contexte de la page et du site Web pour la traduction"
          }
        }
      },
      "botom_banner": {
        "title": "Bénéficiez d'une précision de traduction inégalée avec le",
        "sub_title": "Nouvelle traduction Linguise AI",
        "description": "Linguise améliore ses services de traduction automatique avec l'introduction de Linguise AI Translation, une nouvelle option performante utilisant la technologie de traduction IA de pointe LLM (les modèles Llama les plus récents optimisés pour la traduction). Cette nouveauté offre aux développeurs et agences web une qualité de traduction encore supérieure, idéale pour les projets où la perfection est primordiale. Linguise AI Translation complète notre solution de traduction IA Google Cloud de haute qualité, vous offrant une flexibilité et une précision accrues."
      }
    },
    "success": {
      "tab_title": "Merci d'avoir acheté le plan AI Translation !",
      "title": "Merci d'avoir acheté le plan AI Translation !",
      "subtitle": "Votre plan de traduction AI a été acheté avec succès !",
      "message": "Vous pouvez gérer votre plan de traduction AI dans la page des paramètres de traduction AI.",
      "home": "Gérer la traduction de l'IA"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "Nom",
        "description": "Nom du compte de facturation"
      },
      "phone": {
        "title": "Téléphone",
        "description": "Tél du compte de facturation"
      },
      "email": {
        "title": "Email",
        "description": "Email du compte de facturation"
      },
      "address": {
        "title": "Adresse",
        "description": "Adresse du compte de facturation",
        "city": "Ville",
        "country": "Pays",
        "address1": "Adresse 1",
        "address2": "Adresse 2",
        "postal": "Code postal",
        "state": "État"
      },
      "tax": {
        "title": "Numéro d'identification fiscale"
      }
    }
  },
  "checkouts": {
    "header": "Vérifier",
    "payment_method": "Sélectionnez le mode de paiement",
    "stripe_card": "Carte de crédit (Stripe)",
    "paypal": "Paypal",
    "address": {
      "new": "Entrez la nouvelle adresse de facturation",
      "existing": "Utiliser l'adresse existante"
    },
    "pay_stripe": "Confirmer et payer",
    "terms": "En confirmant votre abonnement, vous autorisez Linguise à vous facturer les paiements futurs conformément à nos conditions. Vous pouvez toujours annuler votre abonnement.",
    "coupon": {
      "title": "Vous avez un coupon ?",
      "placeholder": "Insérez votre code promo ici",
      "apply": "Appliquer",
      "percent": "{{0}} % de réduction"
    },
    "add_new": "Ajouter un nouveau",
    "use_existing": "Utiliser le mode de paiement existant",
    "recurring": {
      "month_single": "Facturé mensuellement",
      "month_many": "Facturé tous les {{count}} mois",
      "year_single": "Facturé annuellement",
      "year_many": "Facturé tous les {{count}} ans",
      "day_single": "Facturé quotidiennement",
      "day_many": "Facturé tous les {{count}} jours",
      "week_single": "Facturé chaque semaine",
      "week_many": "Facturé toutes les {{count}} semaines"
    },
    "add_new_no_stripe": "Ajouter une nouvelle carte",
    "summary": {
      "title": "Résumé",
      "subtotal": "Total",
      "total": "Total"
    }
  },
  "dashboard": {
    "main": {
      "title": "Tableau de bord"
    },
    "statistics": {
      "main_title": "Statistiques des 30 derniers jours",
      "characters": "Caractères traduits",
      "words": "Mots traduits",
      "bandwidth": "Bande passante entrante",
      "request": "Requêtes",
      "page_views": "Pages vues par langue (30 derniers jours)",
      "multilingual_views": "Pages multilingues vues (30 derniers jours)",
      "most_page_viewed": "20 Pages les plues vues (30 derniers jours)",
      "no_data_yet": "Aucune donnée disponible pour le moment",
      "th_language": "Langue",
      "th_page_views": "Pages vues",
      "real_visitors": "Visiteurs réels",
      "crawler": "Robot d’exploration"
    },
    "planHints": {
      "subscribeButton": "Souscrire",
      "upgradeButton": "Améliorer",
      "usedWords": "Vous êtes actuellement {words_used} mots",
      "noPlan": "Aucun plan activé pour ce domaine. Abonnez-vous à un plan et commencez à traduire votre site Web",
      "trialUsage": "Vous utilisez actuellement {words_used} mots sur les {words_allowed} mots inclus dans le plan d'essai.",
      "trialEnds": "L'essai du 1er mois est activé jusqu'en {trial_ends}.",
      "subscribeMessage": "Abonnez-vous avant la fin pour garder votre site Web traduit",
      "trialReachedLimit": "Vous avez atteint le nombre maximum de mots traduits pour la période d'essai.\nAbonnez-vous à l'un de nos plans pour continuer à traduire votre site Web.",
      "paidUsage": "Vous avez utilisé {words_used} des {words_allowed} mots traduits dans votre plan.",
      "paidReachedLimit": "Vous avez atteint le nombre maximal de mots traduits pour le plan actuel.\nMettez à niveau votre plan pour continuer à traduire le contenu de votre site Web.",
      "trialOfferedUsage": "Vous utilisez actuellement {words_used} mots des {words_allowed} mots inclus dans le plan d'essai.(Y compris les {free_words} mots proposés)",
      "paidOfferedUsage": "Vous avez utilisé {words_used} / {words_allowed} mots traduits dans votre plan.(Y compris les {free_words} mots proposés)",
      "noPlanExtra": "Veuillez noter que les domains inactifs sont supprimés automatiquement régulièrement.",
      "planRecommended": "En fonction de votre volume de traduction actuel, le plan recommandé est:",
      "planMaximumWords": "{{words}} mots",
      "notHaveTranslatedWords": "Vous n'avez pas encore fait de traduction",
      "noPlanShopify": "Aucun forfait activé pour ce domaine. Souscrivez à un forfait depuis votre tableau de bord Shopify et commencez à traduire votre site web.",
      "subscribeMessageShopify": "Abonnez-vous depuis votre tableau de bord Shopify avant la fin pour conserver la traduction de votre site Web"
    },
    "translationSetup": {
      "kicker": "CONFIGURATION DU SOUS-DOMAINE",
      "title": "Vérifier la configuration de traduction",
      "description": "Vérifiez le DNS, les hôtes traduits, l’accès au site d’origine et les limites du compte.",
      "starting": "Vérification...",
      "button": "Vérifier la configuration",
      "viewLatest": "Afficher le dernier résultat",
      "viewCurrent": "Afficher la vérification actuelle",
      "runAgain": "Relancer la vérification",
      "viewDetails": "Afficher les détails",
      "hideDetails": "Masquer les détails",
      "error": "Impossible de vérifier la configuration",
      "allPassed": "Toutes les vérifications ont réussi",
      "setupNeedsAttention": "La configuration nécessite votre attention",
      "setupNeedsAttentionDescription": "Une ou plusieurs vérifications ont échoué. Consultez les éléments ci-dessous ou contactez l’assistance Linguise.",
      "lastChecked": "Dernière vérification : {{time}}",
      "domainOwnership": "Propriété du domaine",
      "domainOwnershipDescription": "Enregistrement de vérification trouvé",
      "domainOwnershipFailure": "L’enregistrement DNS de propriété n’a pas pu être vérifié.",
      "translatedHosts": "Hôtes traduits",
      "translatedHostsDescription": "{{count}} hôtes de langue vérifiés",
      "translatedHostsFailure": "Un ou plusieurs enregistrements CNAME de langue sont incorrects.",
      "subdomainPage": "Page du sous-domaine",
      "subdomainPageDescription": "{{count}} pages traduites acceptent HTTPS",
      "subdomainPageFailure": "La connexion TLS a échoué lors de l’ouverture d’une ou plusieurs pages traduites.",
      "originalSite": "Site d’origine",
      "originalSiteDescription": "Vérifications DNS, TLS et réponse du site d’origine",
      "originalSiteFailure": "La vérification DNS, TLS ou de réponse du site d’origine a échoué.",
      "documentationAdvice": {
        "dns": "Vérifier la configuration DNS",
        "tls": "Vérifier la configuration HTTPS",
        "origin": "Vérifier la configuration du site d’origine",
        "diagnostic": "Consulter les étapes de dépannage"
      },
      "evidence": {
        "originDns": "DNS d’origine",
        "originTls": "TLS d’origine",
        "originHttp": "Réponse d’origine",
        "observedTargets": "Cibles détectées",
        "recordCount": "Enregistrements trouvés",
        "addressCount": "Adresses trouvées",
        "statusCode": "Code HTTP",
        "redirect": "Redirection",
        "expiresAt": "Expiration du certificat",
        "raw": "{{key}}",
        "noValue": "Aucune valeur"
      },
      "checkerError": "Certaines vérifications n’ont pas pu être terminées.",
      "coreLocation": "Vérifié depuis {{location}}",
      "status": {
        "queued": "En attente",
        "running": "En cours",
        "completed": "Terminé",
        "failed": "Échec",
        "passed": "Réussi",
        "warning": "Avertissement",
        "unknown": "Inconnu",
        "skipped": "Ignoré",
        "not_applicable": "Non applicable"
      }
    },
    "throttling": {
      "title": "Limite de traduction",
      "description": "Limites d’utilisation temporaires",
      "unavailable": "Limites de traduction temporaires indisponibles",
      "window": "{{used}} / {{max}} mots",
      "resetsIn": "Réinitialisation dans {{time}}",
      "throttled": "Traduction temporairement suspendue",
      "throttledDescription": "Une limite temporaire d’utilisation a été atteinte. La traduction reprendra lors de la réinitialisation de cette période."
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "ÉTAPE {{step}} SUR {{total}}",
      "doneLabel": "FAIT, VOUS POUVEZ COMMENCER À TRADUIRE!",
      "finish": {
        "title": "",
        "description": "Clé API à ajouter pour activer Linguise sur votre site web"
      },
      "instructions": "Instructions d'installation",
      "domainSetting": "Paramètres du domaine",
      "step": {
        "titleWordpress": "Wordpress",
        "titleJoomla": "Joomla",
        "titlePHP": "Script PHP",
        "wizardWordpressStep1": "1. Installer le ",
        "wizardWordpressStep2": "\n 2. Dans les paramètres du plugin, copiez et remplissez votre clé API.\n",
        "wizardWordpressStep3": "3. Vous êtes prêt à traduire\n\n",
        "wizardWordpressStep4": "Pour des instructions plus détaillées, veuillez consulter notre documentation: ",
        "wizardJoomlaStep1": "1. Lien vers le package Joomla: ",
        "wizardJoomlaStep2": "\n2. Dans les paramètres de configuration de l'extension, copiez et remplissez votre clé API.",
        "wizardJoomlaStep4": "\n 4.Vous êtes prêt à traduire\n\n",
        "wizardJoomlaStep3": "3. Dans la configuration du module, définissez les langues que vous souhaitez afficher et insérez votre module là où vous en avez besoin.",
        "wizardPhpStep1": "1. Téléchargez notre script php et ici ",
        "wizardPhpStep2": "\n2. Suivez les instructions d'installation dans notre page de documentation ici ",
        "wizardPhpStep3": "\n3. Ajoutez le module à vos pages.",
        "wizardPhpStep4": "\n Copiez le code suivant et ajoutez-le à l'en-tête de votre page html il affichera automatiquement le module de commutation.\n",
        "dispatchStep1": "Nous avons envoyé avec succès les données requises au plugin Linguise, vous pouvez maintenant fermer la fenêtre suivante.",
        "dispatchStep2": "Si le jeton est manquant lorsque vous fermez cette fenêtre, veuillez copier le jeton suivant :",
        "dispatchStep3": "Vous pouvez également copier cet extrait pour activer automatiquement notre sélecteur de drapeau",
        "wizardOtherStep1": "Suivez les instructions ci-dessous pour installer Linguise sur votre domaine.",
        "wizardOtherStep2": "Copiez le code suivant et ajoutez-le à l'en-tête de votre page HTML, il affichera automatiquement le module de commutation."
      },
      "trialAlreadyUsed": "Il semble que vous ayez déjà utilisé votre essai gratuit, vous devez donc obtenir un quota de traduction\nVeuillez souscrire à un plan ou nous contacter si vous avez besoin de prolonger votre période d'essai",
      "usefulLinks": "Liens utiles pour commencer",
      "linkDocumentation": "Documentation",
      "linkExtensionDl": "Téléchargement de l'extension",
      "linkSubscribe": "Souscrivez un plan maintenant",
      "linkDashboard": "Aller au tableau de bord",
      "exclusion": {
        "title": "Nom de l'entrepris et noms de vos produits",
        "description": ""
      },
      "finishButton": "Terminez la configuration",
      "subdomains": "Sous-domaines",
      "subdomain_setup": "Domaine de configuration",
      "subdomain_auto_setup": "Connectez votre DNS automatiquement",
      "subdomain_manual_setup": "Ajouter moi-même des entrées DNS",
      "subdomain_skip": "Ajouter moi-même des entrées DNS",
      "auto_subdomains_info": "Votre CMS de création de site nécessite une configuration DNS pour définir les langues par sous-domaine (ex. fr.domain.com). Vous pouvez le faire automatiquement en utilisant Entri. Cliquez simplement sur le bouton « Connectez votre DNS automatiquement » pour commencer à vous connecter à votre gestionnaire DNS et ajoutez-les avec Entri. ",
      "auto_subdomains_info_manual": "Vous pouvez également configurer manuellement votre domaine en cliquant sur le bouton « Ajouter moi-même des entrées DNS ».",
      "auto_subdomains_info_2": "Vous pouvez le faire automatiquement en utilisant Entri. Cliquez simplement sur le bouton « Connectez votre DNS automatiquement » pour commencer à vous connecter à votre gestionnaire DNS et ajoutez-les avec Entri. ",
      "breadcrumbs": {
        "step1": "Étape 1 : Domaine, CMS et langues",
        "step2": "Étape 2 : DNS de langue",
        "step3": "Étape {{step}} : Instructions d'installation"
      }
    },
    "form": {
      "urls": {
        "dash": "Tiret haut -",
        "underscore": "Tiret bas _",
        "title": "Traduction des URL",
        "description": "Voulez vous traduire les URL pour toutes les pages?",
        "char_description": "Caractère à utiliser pour remplacer les caractères non autorisés dans les URL (avancé)",
        "advertisement_title": "⚠ Vous avez défini un grand nombre de langues.\n",
        "advertisement": "Nous conseillons généralement de commencer par traduire des sites Web dans un nombre limité de langues. Vous aurez ainsi une idée du nombre de mots que contient votre site. \nC'est également meilleur pour le référencement, car les robots de Google exploreront plus rapidement toutes vos pages si vous avez moins de pages au départ.\nAprès une semaine, vous pouvez ajouter quelques langues supplémentaires, et ainsi de suite."
      },
      "url": {
        "title": "URL",
        "description": "Entrez votre URL de domaine de base commençant par http:// ou https://",
        "placeholder": "URL du domaine",
        "advertisement_http": {
          "title": "Vous n'utilisez pas le protocole https",
          "description": "Veuillez vérifier que votre domain n'utilise pas le protocole https, ce qui est recommandé de nos jours."
        },
        "advertisement_www": {
          "title": "Votre sous-domaine n'est pas www",
          "description": "La plupart du temps le sous-domaine par défaut est www (ex: https://www.mydomain.com). Ce n'est peut-être pas votre cas mais veuillez revérifier que le domaine à ajouter est correct."
        },
        "invalid_url": {
          "line1": "Nous n'avons pas pu trouver votre domaine. Veuillez vérifier que votre domaine est accessible publiquement via Internet et qu'il n'est pas redirigé vers un autre emplacement. ",
          "line2": "Si vous êtes sûr que votre domaine est accessible, vous pouvez ignorer la vérification du domaine et appuyer à nouveau sur le bouton « Étape suivante »",
          "contact": "Dans tous les cas, vous pouvez nous contacter à ",
          "force": "Ignorer la vérification du domaine"
        },
        "invalid_subdomain_url": "Cette URL n'est pas autorisée. Les sous-domaines doivent être au format : https://www.domain.tld ou https://domain.tld sans sous-répertoire."
      },
      "account": {
        "title": "Compte",
        "description": "Sélectionnez un compte pour attribuer ce domaine",
        "placeholder": "Sélectionnez un compte ...",
        "feedback": "Vous devez choisir un compte"
      },
      "platform": {
        "title": "Plate-forme",
        "description": "Veuillez sélectionner la plateforme de votre site Web par nom CMS.",
        "learn": "Apprenez à le choisir",
        "placeholder": "Plateforme de recherche par nom de CMS...",
        "info": {
          "title": "⚠ Cette plateforme a été ajoutée récemment.\n",
          "desc": "Cette plateforme de création de sites Web est prise en charge par Linguise, bien qu'elle ait été ajoutée récemment. Si vous rencontrez un problème, veuillez nous contacter en utilisant l'e-mail d'assistance direct:"
        },
        "description_read_only": "La plateforme utilisée par votre site Web",
        "feedback": "Vous devez choisir une plateforme"
      },
      "language": {
        "title": "Langue",
        "description": "Sélectionnez la langue de base de votre site",
        "placeholder": "Sélectionnez une langue",
        "feedback": "Veuillez sélectionner une langue",
        "description_read_only": "Langue de base de votre site"
      },
      "token": {
        "title": "Clé API",
        "description": "Clé API que vous devez utiliser sur votre site",
        "copy": "Copie press papier",
        "reset": "Réinitialiser API Key",
        "reset_confirm": "Veuillez confirmer la réinitialisation du API Key"
      },
      "languages": {
        "title": "Langues traduites",
        "description": "Sélectionnez les langues dans lesquelles vous voulez traduire votre site",
        "placeholder": "Sélectionnez des langues",
        "feedback": "Veuillez sélectionner au moins une langue"
      },
      "defaultRules": {
        "title": "Règles par défaut",
        "description": "Nous avons défini un ensemble de règles à utiliser pour améliorer la traduction et éviter que le contenu indésirable ne soit traduit, comme le tableau de bord WordPress.\nVous pouvez supprimer ou modifier ces règles ultérieurement si vous le souhaitez."
      },
      "disallow_deletion": "Vous ne pouvez pas supprimer un domaine avec un abonnement actif",
      "delete_confirm": "Veuillez confirmer la suppression du domaine",
      "delete": "Supprimer le domaine",
      "dynamic": {
        "title": "Traduire du contenu dynamique",
        "description": "Le contenu dynamique généré par les requêtes JavaScript et AJAX sera traduit (cette option augmentera vos utilisations de traduction)"
      },
      "partial_translations": {
        "title": "Autoriser la traduction partielle",
        "description": "Si votre compte a atteint son quota de traduction mais que la page nécessite encore une traduction, Linguise peut continuer à afficher la page avec le contenu déjà traduit. Cependant, certaines parties de la page resteront non traduites jusqu'à ce que vous mettiez à niveau votre quota. Même si une petite quantité de contenu non traduit ne nuira généralement pas au référencement, autoriser trop de contenu non traduit pourrait avoir un impact négatif sur l'expérience utilisateur. Pour résoudre ce problème, vous pouvez définir un seuil pour le pourcentage de contenu non traduit autorisé sur une page. Si le contenu non traduit dépasse ce seuil, les utilisateurs seront automatiquement redirigés vers la version linguistique originale de la page.",
        "never": "Jamais"
      },
      "translate_error_pages": {
        "title": "Traduire les pages d'erreur",
        "description": "Linguise peut traduire toutes les pages d'erreur, mais si votre page d'erreur contient du contenu dynamique, comme une adresse IP ou un identifiant de demande, vous devez éviter de traduire ces pages.",
        "not_found_page": {
          "title": "Traduire la page 404"
        },
        "error_page": {
          "title": "Traduire d'autres pages d'erreur"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "Domaine existant trouvé",
          "description": "Un domaine existant a été trouvé pour cet utilisateur, souhaitez-vous l'utiliser ?"
        }
      },
      "search_tl": {
        "title": "Rechercher des traductions",
        "description": "Activer les traductions de recherche pour la plateforme de votre site Web (expérimental, cette option augmentera vos utilisations de traduction)"
      },
      "shopify_promo": {
        "info": "Bonne nouvelle ! Nous avons maintenant une application native Shopify que vous pouvez installer depuis l'App Store de Shopify.",
        "hyperlink": "Cliquez ici et procédez à l'installation de Linguise depuis l'application.",
        "next_btn": "Rendez-vous sur la boutique Shopify pour installer l'application.",
        "info_legacy": "Bonne nouvelle ! Nous avons maintenant une application native Shopify que vous pouvez installer depuis l'App Store de Shopify.",
        "description_legacy": "Sélectionnez la plateforme \"Shopify\" au lieu de \"Shopify Legacy\""
      },
      "wix_promo": {
        "info": "Bonne nouvelle ! Nous avons maintenant une application native Wix que vous pouvez installer depuis le Wix App Market.",
        "hyperlink": "Cliquez ici et procédez à l'installation de Linguise depuis l'application.",
        "next_btn": "Rendez-vous sur le Wix App Market pour installer l'application.",
        "info_legacy": "Bonne nouvelle ! Nous avons maintenant une application native Wix que vous pouvez installer depuis le Wix App Market.",
        "description_legacy": "Sélectionnez la plateforme \"Wix\" au lieu de \"Wix Legacy\""
      },
      "ai_disallow_deletion": "Vous ne pouvez pas supprimer ce domaine tant qu'un quota d'IA est disponible. Veuillez contacter notre équipe d'assistance si vous souhaitez supprimer ce domaine.",
      "language_removal": {
        "card": {
          "title": "Supprimer les traductions des langues retirées",
          "description": "Ces langues ont été retirées de votre site, mais leurs traductions enregistrées sont toujours décomptées de votre quota. Supprimez-les pour récupérer les mots.",
          "button": "Supprimer les traductions"
        },
        "hint": "Les mots utilisés seront rendus à votre quota. Vous pouvez le faire une fois tous les {{days}} jours pour chaque site.",
        "modal": {
          "title": "Supprimer les traductions ?",
          "intro": "Ces traductions seront définitivement supprimées :",
          "warning": "Cette action est irréversible. Les mots utilisés seront rendus à votre quota, ce qui peut prendre quelques minutes.",
          "limit": "Vous pouvez le faire une fois tous les {{days}} jours pour chaque site.",
          "confirm": "Supprimer les traductions"
        },
        "scheduled": "Les traductions sont en cours de suppression et votre quota sera bientôt mis à jour.",
        "cooldown": "Les traductions de ce site ont été supprimées récemment. Vous pourrez les supprimer à nouveau le {{date}}.",
        "latest_completed": {
          "title": "Dernière suppression terminée",
          "description": "Consultez les langues supprimées et les mots rendus à votre quota.",
          "languages": "Langues supprimées",
          "words_returned": "Mots rendus à votre quota : {{words}}",
          "completed_at": "Terminé le {{date}}"
        },
        "status": {
          "recent_title": "Suppression récente de traductions",
          "recent_description": "Suivez la dernière suppression et voyez quand vous pourrez en lancer une autre.",
          "progress_title": "Progression de la suppression",
          "loading": "Vérification de la progression de la suppression...",
          "unavailable": "Impossible de charger la progression de la suppression. Actualisez la page et réessayez.",
          "label": "Statut",
          "pending": "En attente",
          "processing": "En cours",
          "completed": "Terminé",
          "failed": "Échec",
          "unknown": "Statut indisponible",
          "percent": "{{percent}} % terminé",
          "current_stage": "Étape actuelle : {{stage}}",
          "processed": "{{processed}} enregistrements traités",
          "processed_total": "{{processed}} enregistrements sur {{total}} traités",
          "requested_at": "Demandé le {{date}}",
          "started_at": "Démarré le {{date}}",
          "completed_at": "Terminé le {{date}}",
          "cooldown_period": "Vous pouvez le faire une fois tous les {{days}} jours pour chaque site.",
          "cooldown_blocked": "Une autre suppression ne peut pas encore être lancée.",
          "stage": {
            "queued": "En attente du démarrage",
            "processing": "En cours",
            "refund_summary": "Calcul des mots rendus",
            "search_translations": "Suppression des traductions de recherche",
            "url_translations": "Suppression des traductions d’URL",
            "translations": "Suppression des traductions",
            "completed": "Terminé",
            "failed": "Échec",
            "unknown": "En cours"
          }
        },
        "forbidden": "Vous n’avez pas l’autorisation de supprimer des traductions."
      }
    },
    "main": {
      "edit": "Modifier un domaine",
      "add": "Ajouter un domaine",
      "wizard": "Bienvenue ! suivez le guide d'ajout d'un nouveau site à traduire.",
      "common": "Domaine"
    },
    "subdomains": {
      "config_ok": "Le DNS des sous-domaines a été configuré correctement.",
      "config_invalid": "Le DNS des sous-domaines nécessite une configuration supplémentaire pour fonctionner.",
      "config_check": "La configuration DNS des sous-domaines est en cours de vérification, veuillez patienter...",
      "entri_timeout": "Entri a signalé que le processus de propagation DNS de vos sous-domaines a expiré. Vous devrez réessayer ou vous pouvez le faire manuellement.",
      "entri_process": "Votre DNS a été ajouté avec Entri et la propagation prend généralement 10 à 30 minutes (appliquez tous les sous-domaines de vos langues comme fr.domain.com). Si la validation DNS n'est pas terminée après 24 heures, vous pouvez joindre notre équipe d'assistance : support@linguise.com ",
      "entri_ok": "La propagation du DNS est en route ! En attente de propagation... ",
      "infos": "Vous devez ajouter ces entrées DNS à vos enregistrements de domaine DNS pour activer la traduction. Cliquez sur le bouton de validation une fois l'opération terminée. La propagation des enregistrements DNS peut prendre un certain temps ; vous devrez peut-être réessayer dans quelques minutes ou quelques heures.",
      "check": "Vérifiez la configuration DNS"
    },
    "notice": {
      "broken_card": "Nous n'avons pas pu renouveler votre forfait pour {{url}} en utilisant le mode de paiement actuel. Veuillez mettre à jour votre carte de paiement.",
      "quota_reached": "Votre quota de traduction pour {{url}} a été atteint. Veuillez mettre à niveau pour reprendre la traduction de votre site Web.",
      "important": "Important",
      "quota_reached_button": "Mettez à niveau votre forfait maintenant",
      "broken_card_button": "Mettez à jour votre carte de paiement",
      "ai_no_subscription": "La traduction par IA pour {{url}} nécessite un abonnement ou un essai actif. Sans abonnement, la traduction sera interrompue. Veuillez effectuer une mise à niveau pour continuer.",
      "ai_no_subscription_button": "Mettez à niveau votre forfait maintenant",
      "quota_warning": "Votre quota de traduction pour {{url}} a atteint {{throttling_used_percent}}%, il sera réinitialisé dans {{ttl}}",
      "locked": "Le domaine {{url}} est actuellement verrouillé pour la migration, vous pouvez toujours accéder à votre site mais vous ne pouvez pas modifier ou ajouter de nouvelles traductions !"
    },
    "subscription": {
      "next_payment_amount": "Frais à venir",
      "next_payment_date": "Prochaine date de paiement",
      "invoice": {
        "header": "Historique des factures",
        "date": "Date",
        "amount_due": "Montant",
        "status": "Statut",
        "actions": "Actes",
        "description": "Une fois les transactions disponibles, vous pouvez les consulter ici.",
        "status_text": {
          "draft": "Brouillon",
          "open": "En attente",
          "paid": "Payé",
          "uncollectible": "Irrécupérable",
          "void": "Vide",
          "failed": "Échoué",
          "retrying": "Réessayant"
        },
        "view": "Voir",
        "empty": "Aucune facture récente n'est trouvée pour cet abonnement",
        "retry_payment": "Réessayer"
      },
      "next_cancellation": "Date d'annulation",
      "cancel": "Annuler l'abonnement",
      "change_plan": "Changer de forfait",
      "change": "Changement",
      "suspend": "Suspendre le paiement",
      "resume": "Reprendre l'abonnement",
      "back": "Dos",
      "save": "Sauvegarder",
      "confirm_resume": "Êtes-vous sûr de vouloir reprendre cet abonnement ?",
      "confirm_cancel": "Êtes-vous sûr de vouloir annuler cet abonnement ?",
      "confirm_header": "Es-tu sûr?",
      "missing_status": "Cet abonnement est manquant",
      "not_found": "Aucun abonnement trouvé pour ce domaine",
      "no_payment_method": "Inconnu",
      "remove_billing": "Retirer",
      "confirm_manual_retry": "Êtes-vous sûr de vouloir réessayer ce paiement ?",
      "shopify_maneged": "Cet abonnement est géré par Shopify. Veuillez le gérer depuis votre interface d'administration Shopify.",
      "unknown_plan": "Plan inconnu"
    }
  },
  "domain_listing": {
    "add": "Ajouter un site web",
    "select": "Choisissez un domaine"
  },
  "editable": {
    "number": "nombre {{id}}"
  },
  "footer": {
    "about": "A propos",
    "support": "Soutien"
  },
  "frontendEditor": {
    "main": "Editeur en ligne",
    "description": "L'éditeur en ligne vous aide à traduire visuellement en cliquant directement sur le texte à traduire sur votre site.",
    "button": "Ouvrir l'éditeur en ligne",
    "language_selection": "Sélection de la langue de traduction",
    "video_label": "Apprenez à utiliser l'éditeur en direct"
  },
  "general": {
    "403": {
      "tab_title": "Oups - Erreur 403",
      "title": "Accès refusé",
      "message": "Il semble que vous n’ayez pas accès à la page demandée.",
      "home": "Revenir à l'accueil"
    },
    "404": {
      "tab_title": "Oups - Erreur 404",
      "title": "Erreur 404",
      "message": "Il semble que vous vous soyez égaré. Ne vous inquiétez pas... ça arrive aux meilleurs d'entre nous. Voila un lien qui vous permettra de retrouver votre chemin",
      "home": "Revenir à l'accueil"
    },
    "500": {
      "tab_title": "Oups - Erreur 500",
      "title": "Erreur interne",
      "message": "Essayez de rafraichir la page, ou contactez nous.",
      "home": "Revenir à l'accueil"
    },
    "fields": {
      "alert": "Certain champs ne sont pas valides, veuillez les modifier.",
      "invalid": "Ce champ n'est pas valide",
      "phone_re": "Le numéro de téléphone n'est pas valide",
      "phone_invalid": "Le numéro de téléphone n'est pas valide",
      "email": "Le champ e-mail est invalide."
    },
    "saving": "Enregistrement ...",
    "save": "Enregistrer",
    "save_and_quit": "Enregistrer et quitter",
    "invite": "Inviter",
    "cancel": "Annuler",
    "yes": "Oui",
    "no": "Non",
    "nextStep": "Etape suivante",
    "loading": "Veuillez patienter pendant le chargement",
    "goback": "Retour",
    "manage": "Gérer",
    "delete": "Supprimer",
    "deleting": "Suppression ...",
    "table": {
      "no_data": "Il n'y a pas encore de données ici..."
    },
    "confirm": "Confirmer",
    "unknown": "Inconnu",
    "hide": "Cacher",
    "show": "Montrer",
    "on": "Sur",
    "off": "Désactivé",
    "default": "Par défaut"
  },
  "home": {
    "header": "Accueil",
    "manage": "Gérer l'abonnement",
    "activate_now": "Activer maintenant",
    "activate_plan_now": "Abonnez-vous maintenant",
    "upgrade_plan_now": "Plan de mise à niveau maintenant",
    "trial_message_part_1": "Vous êtes actuellement sur le plan d'essai, ",
    "trial_message_part_2": "vous pouvez activer un abonnement à tout moment.",
    "add": "Ajouter un domaine",
    "table": {
      "title": "Domaines",
      "description": "Liste de vos domaines, cliquez sur le domaine pour gérer les traductions"
    },
    "domains": {
      "empty": "Vous n'avez aucun domaine pour ce compte"
    },
    "accountsList": {
      "title": "Comptes",
      "add": "Ajouter un nouveau compte",
      "name": "Nom du compte"
    },
    "update_credit_card": "Mettre à jour les détails de la carte de crédit",
    "canceled": "Abonnement annulé",
    "cancelling_subs": "Annulation à {{0}}",
    "resume_subscription": "Reprendre l'abonnement",
    "shopify_managed": "Géré par Shopify",
    "trial_ends_at": "Se termine à {{0}}",
    "free_trial": "Essai gratuit",
    "no_subs": "Pas d'abonnement actif"
  },
  "invoices": {
    "title": "Factures",
    "list": {
      "title": "Liste factures"
    },
    "table": {
      "customer": "Utilisateur",
      "domain": "Domaine",
      "amountPaid": "Montant payé",
      "status": "Statut",
      "date": "Date",
      "invoice": "Facture",
      "pay": "Payer la facture",
      "actions": "Actes",
      "deleted_domain": "Domaine supprimé",
      "plan_name": "Plan",
      "action": "Action"
    },
    "listPending": {
      "title": "Liste des factures en attente"
    }
  },
  "language_settings": {
    "display": "Affichage de la liste des langues",
    "position": "Position",
    "display_help_text": "Afficher les drapeaux et/ou les noms de langue. La position par défaut du sélecteur de langue peut être n'importe où dans le contenu ou dans une position fixe qui reste fixe ou se déplace lors du défilement",
    "side_by_side": "Cote à cote",
    "dropdown": "Menu déroulant",
    "popup": "Surgir",
    "flag": "Drapeau",
    "lang_name": "Nom de la langue",
    "lang_short_name": "Noms courts",
    "positions": {
      "in_place": "En place",
      "top_left": "En haut à gauche",
      "top_left_no_scroll": "En haut à gauche (sans défilement)",
      "top_right": "En haut à droite",
      "top_right_no_scroll": "En haut à droite (sans défilement)",
      "bottom_left": "En bas à gauche",
      "bottom_left_no_scroll": "En bas à gauche",
      "bottom_right": "En bas à droite",
      "bottom_right_no_scroll": "En bas à droite (sans défilement)"
    },
    "lang_names_display": {
      "title": "Affichage des noms de langue",
      "help_text": "Dans le sélecteur de langue, affichez les noms de langue en anglais ou dans la langue d'origine, c'est-à-dire français ou français",
      "english": "Anglais",
      "native_languages": "Langue maternelle"
    },
    "flag_shape": {
      "title": "Modèle de drapeau",
      "help_text": "Utilisez des icônes de drapeau svg rondes ou rectangulaires svg",
      "round": "Rond",
      "rectangular": "Rectangulaire"
    },
    "english_flag_type": {
      "title": "Type de drapeau anglais",
      "help_text": "Utilisez le drapeau de la Grande-Bretagne ou des États-Unis pour l'anglais",
      "usa": "Drapeau des Etats Unis",
      "great_britain": "Drapeau de la Grande-Bretagne"
    },
    "german_flag_type": {
      "title": "Type de drapeau allemand",
      "help_text": "Utilisez le drapeau autrichien ou allemand pour l'allemand",
      "german": "Drapeau allemand",
      "austria": "Drapeau Autriche"
    },
    "spain_flag_type": {
      "title": "Type de drapeau espagnol",
      "help_text": "Utilisez le drapeau mexicain ou espagnol pour l'espagnol",
      "spanish": "Drapeau espagnol",
      "mexico": "Drapeau du Mexique",
      "peruvian": "Drapeau péruvien"
    },
    "portugal_flag_type": {
      "title": "Type de drapeau portugais",
      "help_text": "Utilisez le drapeau portugais ou brésilien pour le portugais",
      "portugal": "Drapeau portugais",
      "brazil": "Drapeau Brésilien"
    },
    "taiwanese_flag_type": {
      "title": "Type de drapeau taïwanais",
      "help_text": "Utilisez le drapeau taïwanais ou chinois pour les Taïwanais",
      "taiwanese": "Drapeau taïwanais",
      "chinese": "Drapeau chinois"
    },
    "flag_border_radius": {
      "title": "Rayon de la bordure du drapeau (px)",
      "help_text": "Si vous utilisez la forme du drapeau rectangulaire, vous pouvez appliquer un rayon de bordure personnalisé en pixels"
    },
    "flag_width": {
      "title": "Taille du drapeau (px)",
      "help_text": "Sélectionnez la taille des drapeaux en pixels. Cela ne change pas le poids de l'image car il s'agit d'un format .svg"
    },
    "lang_color": {
      "color_title": "Couleur du nom de la langue",
      "color_help_text": "Sélectionnez une couleur de texte par défaut pour vos noms de langue",
      "hover_color_title": "Couleur de survol du nom de la langue",
      "hover_color_help_text": "Sélectionnez une couleur de texte de survol de la souris pour vos noms de langue",
      "color_popup_title": "Couleur de la langue contextuelle",
      "color_popup_help_text": "Couleur du titre de la langue dans la popup ou dans les zones déroulantes",
      "hover_color_popup_title": "Couleur de survol de la langue contextuelle",
      "hover_color_popup_help_text": "Sélectionnez une couleur de texte de survol de la souris du titre de la langue dans la fenêtre contextuelle ou dans les zones déroulantes"
    },
    "flag_box_shadow": {
      "shadow_title": "Ombre de boîte de drapeau",
      "shadow_help_text": "Couleur et taille d'ombre pour vos drapeaux de langue",
      "hover_shadow_title": "Drapeau boîte ombre sur vol stationnaire",
      "hover_shadow_help_text": "Couleur et taille d'ombre pour vos drapeaux de langue au survol de la souris",
      "shadow_h_offset": "Décalage de l'ombre H (px)",
      "shadow_v_offset": "Décalage Shadow V (px)",
      "shadow_blur": "Flou d'ombre (px)",
      "shadow_spread": "Propagation des ombres (px)",
      "shadow_color": "Couleur de l'ombre"
    },
    "order": "Ordre des langues",
    "language_order_help": "L'ordre de la langue qui sera affichée dans le sélecteur de langue. Vous pouvez faire glisser et déposer la langue pour les réorganiser. ",
    "order_reset": "Réinitialiser la commande",
    "language_order_dragdrop": "Vous pouvez faire glisser et déposer la langue pour les réorganiser.",
    "popup_lang_name": "Nom de la langue contextuelle",
    "preview": "Aperçu de la langue"
  },
  "link": {
    "form": {
      "original": {
        "title": "Source originale",
        "description": "Ajoutez votre URL de lien d'origine et remplacez-la ci-dessous par la langue pour les traduire",
        "srcset_description": "Vous modifiez l'URL d'une image. Assurez-vous de lire la documentation, surtout si vous utilisez srcset ou si vous ne savez pas de quoi il s'agit",
        "link": "Lien",
        "match_link": "Mode match",
        "match_exact": "Exact",
        "match_wildcard": "Caractère générique",
        "match_regex": "expression régulière"
      },
      "alternative_languages": {
        "title": "Liens à remplacer",
        "description": "Remplacez les liens médias et les liens externes sur toutes vos pages, par langue...",
        "link": "Lien à remplacer"
      },
      "error": {
        "atLeastOne": "Veuillez ajouter au moins une traduction.",
        "url": "L'url est invalide",
        "extension": "Le lien doit avoir une extension, mais il ne peut pas s'agir de .html ou .php. Et le lien ne doit contenir aucun chemin de langue, par ex. \"/fr\"",
        "regex": "L'expression régulière n'est pas valide",
        "wildcard": "Le lien générique a un protocole non valide"
      }
    },
    "main": {
      "parent": "Liens",
      "edit": "Modifier le lien"
    }
  },
  "links": {
    "title": "Gestion des médias et des liens externes",
    "description": "Répertorier et modifier votre site Web Liens médias ou liens externes.",
    "add": "Ajouter un lien",
    "delete": "Supprimer le lien",
    "table": {
      "original": "Original",
      "language": "Langue",
      "translation": "Traduction",
      "action": "Action",
      "delete_confirm": "Veuillez confirmer la suppression du lien"
    }
  },
  "members": {
    "header": "Membres",
    "invite": "Inviter un nouveau membre",
    "modal": {
      "inviteHeader": "Inviter un nouveau membre",
      "editHeader": "Modifier le membre",
      "detachHeader": "Détacher un membre",
      "detachBody": "Voulez-vous vraiment dissocier le membre de ce compte?",
      "selfDetachBody": "Etes-vous sûr de vouloir vous détacher de cette gestion de compte ? Après cela, vous ne pourrez accéder à aucune des données liées à ce compte. "
    },
    "table": {
      "title": "Liste des membres",
      "description": "Accès aux rôles et domaines des membres",
      "name": "Nom",
      "email": "Email",
      "websites": "Sites Internet",
      "languages": "Langue",
      "role": "Rôle",
      "status": "Statut",
      "resendInvite": "renvoyer",
      "inviteSent": "l'invitation a été envoyée",
      "actions": "Actions",
      "edit": "Éditer",
      "detach": "Détacher",
      "empty": "Vous n'avez pas encore de membres",
      "all_website": "Tous les sites Web et langues",
      "roles": {
        "admin": "Administrateur",
        "manager": "Gestionnaire",
        "translator": "Traducteur"
      },
      "statuses": {
        "pending": "En attente",
        "accepted": "Accepté",
        "declined": "Refusé"
      }
    },
    "errors": {
      "role": "Vous devez choisir un rôle",
      "domains": "Vous devez choisir au moins 1 site Web pour le rôle sélectionné",
      "languages": "Vous devez choisir au moins une langue pour les sites Web sélectionnés"
    },
    "inviteSent": "Votre invitation a été envoyée avec succès"
  },
  "pagination": {
    "showing": "Affichage de {{limit}} sur {{total}} résultats",
    "showing_only_count": "Affichage de {{limit}} résultats"
  },
  "payments_method": {
    "header": "Méthodes de paiement",
    "table": {
      "title": "Liste des modes de paiement",
      "description": "Modes de paiement attachés à votre compte",
      "default": "Défaut",
      "action_edit_remove": "Modifier ou supprimer",
      "action_remove": "Retirer",
      "action_default": "Définir par défaut",
      "action_fallback": "Définir comme solution de secours",
      "expires": "Expire",
      "add_new_card": "Ajouter un mode de paiement",
      "action_fallback_remove": "Supprimer de la solution de secours",
      "fallback": "Secours",
      "action_edit": "Modifier",
      "action_delete": "Supprimer",
      "action_default_remove": "Supprimer par défaut",
      "domain_count@@one": "Utilisé par {{count}} domaines",
      "domain_count@@other": "Utilisé par {{count}} domaines"
    },
    "paypal_bind": {
      "button": "Connecter le compte PayPal",
      "button_load": "De liaison...",
      "disconnected": "Non connecté",
      "error": "Une erreur s'est produite",
      "success_header": "Succès",
      "success_no_promo": "Votre compte PayPal est désormais connecté",
      "success": "Votre compte PayPal est maintenant connecté, 5$ seront déduits de votre prochaine facture !"
    },
    "card_add": {
      "header": "Ajouter une nouvelle carte",
      "success": "Nouvelle carte connectée à Linguise !",
      "terms": "En fournissant les informations de votre carte, vous autorisez Linguise à débiter votre carte pour les paiements futurs conformément à nos conditions de service."
    },
    "card_detail": {
      "header": "Informations sur la carte",
      "delete": {
        "error": "Vous ne pouvez pas supprimer ce mode de paiement car il a des abonnements actifs !"
      }
    },
    "subscriptions": {
      "table": {
        "description": "Abonnements sur ce mode de paiement",
        "header_domain": "Domaine",
        "header_plan": "Plan",
        "header_status": "Statut",
        "header_actions": "Actes",
        "cancelling": "Annulation à : {{0}}",
        "next_payment": "Prochain paiement à : {{0}}",
        "action_renew": "Renouveler",
        "no_subs_header": "Aucun abonnement à afficher",
        "no_subs_desc": "Une fois l'abonnement effectué sur cette carte, toutes les informations seront affichées ici",
        "action_manage": "Gérer"
      },
      "status": {
        "active": "Actif",
        "canceled": "Annulé",
        "incomplete": "Non rémunéré",
        "incomplete_expired": "Impayé (expiré)",
        "past_due": "En souffrance",
        "trialing": "Procès",
        "unpaid": "Non rémunéré",
        "missing": "Erreur"
      }
    },
    "delete_confirm_body": "Etes-vous sûr de vouloir supprimer ce mode de paiement ? Cette action est irréversible !",
    "delete_confirm_header": "Supprimer le mode de paiement ?",
    "card_edit": {
      "header": "Modifier la carte",
      "billing_header": "Informations de facturation",
      "address_error": "L'adresse est obligatoire !",
      "card_number": "Numéro de carte",
      "card_expiry": "Date d'expiration",
      "expiry_error_month": "Mois fourni non valide",
      "expiry_error_year": "Année fournie non valide",
      "expiry_error_expired": "L'année d'expiration de votre carte est passée.",
      "card_header": "Informations sur la carte",
      "expiry_error_empty": "Ce champ est obligatoire!"
    }
  },
  "plans": {
    "per": "par",
    "wordsTranslated": "mots traduits",
    "current": "Actuel",
    "archived": "Archivé",
    "day": "jour",
    "week": "semaine",
    "month": "mois",
    "year": "année",
    "activate": "Activer",
    "cancel": "Annuler",
    "change": "Modifier",
    "upgrade": "Améliorer",
    "downgrade": "Rétrograder",
    "notEnoughWords": "Pas assez de mots",
    "yearIntervalOnly": "Impossible de migrer à partir du plan annuel",
    "wordsUnlimited": "Mots illimités",
    "tabs": {
      "day": "Prix journaliers",
      "week": "Prix à la semaine",
      "month": "Prix mensuels",
      "year": "Prix annuels",
      "sub_texts": {
        "day": "Un prix fixe, tous les jours",
        "week": "Un prix fixe, chaque semaine",
        "month": "Un prix fixe, chaque mois",
        "year": "Un mois gratuit, une facture par an"
      }
    },
    "details": {
      "new_languages": "Ajoutez de nouvelles langues à tout moment",
      "one_month_trial": "Essai gratuit d'un mois pour chaque nouveau site Web",
      "multi_content_indexed": "100% des contenus multilingues indexés",
      "translate_new_content": "Traduisez instantanément du nouveau contenu",
      "free_installation": "Installation et configuration gratuites",
      "compared_monthly_plan": "Un mois gratuit par rapport aux forfaits mensuels",
      "risk_free_recurring": "Échec de paiement récurrent sans risque",
      "unlimited_languages": "Langues et pages vues illimitées",
      "high_server_resources": "Ressources de serveur élevées",
      "billed": {
        "day": "Facturé quotidiennement",
        "week": "Facturé chaque semaine",
        "month": "Facturé mensuellement",
        "year": "Facturé annuellement"
      },
      "request_max_size": "Taille maximale de la demande de {{0}}"
    },
    "frequent_question": {
      "title": "Questions fréquentes",
      "questions": {
        "trial": {
          "question": "Puis-je utiliser la version d'essai sur un nouveau domaine de site Web?",
          "answer": "Oui, nous proposons un essai gratuit de 30 jours pour chaque nouveau domaine de site Web que vous ajoutez à votre compte. De cette façon, vous pouvez tester pleinement le service de traduction sur votre nouveau site Web."
        },
        "seo": {
          "question": "Combien de temps faut-il pour que mon référencement s’améliore ?",
          "answer": "Le contenu et le contenu multilingue mettent du temps à être entièrement indexés et bien classés. Selon le trafic et la taille de votre site Web, cela prend entre 3 et 6 semaines."
        },
        "quota": {
          "question": "Les traductions humaines sont-elles incluses dans le quota ?",
          "answer": "Non, la limite du nombre de mots concerne uniquement les traductions automatiques. Un traducteur peut éditer manuellement des traductions automatiques sans limite."
        }
      }
    },
    "best_offer": "Meilleure offre",
    "resume": "CV",
    "subsCanceled": "Il y a une autre annulation d'abonnement en cours",
    "period": {
      "days@@one": "jour",
      "days@@other": "{{count}} jours",
      "hours@@one": "heure",
      "hours@@other": "{{count}} heures",
      "minutes@@one": "minute",
      "minutes@@other": "{{count}} minutes",
      "seconds@@one": "deuxième",
      "seconds@@other": "{{count}} secondes"
    },
    "words": {
      "billion": "{{value}} G",
      "million": "{{value}} M",
      "thousand": "{{value}} k"
    },
    "throttling_info": "{{words}} mots par {{period}}"
  },
  "profile": {
    "welcome": "Bienvenue !",
    "account": "Mon compte",
    "subscriptions": "Souscriptions",
    "logout": "Se déconnecter"
  },
  "register": {
    "errors": {
      "password": "Minimum 8 caractères, n'importe quel caractère"
    }
  },
  "route": {
    "dashboard": "Tableau de bord",
    "rules": "Règles",
    "translations": "Traductions",
    "search_translations": "Traduction des recherches",
    "urls_translations": "Traductions des URLs",
    "links": "Médias et liens externes",
    "online_editor": "Éditeur en ligne",
    "settings": "Configuration",
    "domain": {
      "finish": "Configuration",
      "preconfig": "Configuration"
    },
    "home": "Accueil",
    "domain_list": "Liste de domaines",
    "members": "Membres",
    "invoices": "Factures",
    "billing": "Détails de la facturation",
    "language_display": "Affichage des drapeaux de langue",
    "payment_methods": "Méthodes de paiement",
    "ai_translation": "Traduction IA",
    "ai_translation_settings": "Paramètres",
    "ai_translation_pricing": "Tarification"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "Texte à ignorer",
        "add": "Ajouter",
        "title": "Ignorer du texte",
        "description": "Ajoutez un ou plusieurs textes à ignorer",
        "ignore_case": "Ignorer la casse"
      },
      "html_content": {
        "title": "Appliquer au contenu html",
        "description": "Appliquer la règle sur tout le contenu ou en choisissant un sélecteur CSS",
        "all_page": "Toute la page",
        "css_selector": "Sélecteur CSS",
        "label": "Sélecteur CSS",
        "placeholder": "Sélecteur CSS",
        "add": "Ajouter"
      },
      "apply_to_urls": {
        "title": "Appliquer aux URLs",
        "description": "Sélectionnez les URLs auxquelles vous souhaitez que la règle s'applique (sans le nom de domaine ni le préfixe de langue)",
        "all_urls": "Toutes les URLs",
        "selected_urls": "Les URLs sélectionnées",
        "label": "URLs concernées",
        "placeholder": "URL",
        "original_url": "URL Originale",
        "translated_url": "URL Traduite",
        "wildcard": "Caractère générique *",
        "regex": "Expression régulière",
        "add": "Ajouter",
        "expression": "Type d'expression"
      },
      "apply_urls": {
        "title_exclude": "Exclure des URLs",
        "title_replace": "Remplacer dans les URLs",
        "title_description": "Appliquer également cette règle à la traduction des URLs"
      },
      "apply_languages": {
        "title": "Appliquer aux langues",
        "description": "Choisissez les langues pour lesquelles appliquer la règle",
        "all_languages": "Toutes les langues",
        "selected_languages": "Langues sélectionnées",
        "placeholder": "Sélectionnez des langues...",
        "feedback": "Vous devez choisir une langue"
      },
      "name": {
        "title": "Titre",
        "description": "Donner un titre à votre règle pour l'identifier",
        "placeholder": "Titre de la règle"
      },
      "type": {
        "title": "Type",
        "description": "Choisissez le type de règle à ajouter",
        "text_ignore": "Ignorer du texte",
        "text_replace": "Remplacement de texte",
        "content_exclusion": "Exclusion de contenu",
        "url_exclusion": "Exclusion d'URL de la traduction",
        "ignore_inline": "Ignorer le contenu en ligne",
        "full_description": {
          "text_ignore": "Ajoute des règles pour éviter que certains contenus ne soient pas traduits. Cela peut être un nom de produit, de société, ou tout autre élément technique que vous ne voulez pas traduire.",
          "text_replace": "Cette règle permet de remplacer la traduction par ce que vous voulez, cela peut être nécessaire quand la traduction ne suite pas bien le contexte de la page.",
          "content_exclusion": "L'exclusion de contenu permet d'éviter la traduction d'une partie du site.\n Si vous voulez exclude complètement une page de la traduction (pas d'URL multilingue ni de contenu traduit) veuillez utiliser le type \"Exclusion d'URL de la traduction\"",
          "url_exclusion": "L'exclusion de page vous permet de définir les pages que vous ne souhaitez pas traduire",
          "ignore_inline": "Évitez de traduire certains contenus en tant que contenu en ligne, traduire plutôt chaque balise séparément."
        }
      },
      "text_replace": {
        "title": "Texte à remplacer",
        "description": "Remplacez du texte par la traduction que vous souhaitez. Remplacez n'importe quel texte dans n'importe quelle page, langue…",
        "text_to_replace": "Texte à remplacer",
        "ignore_case": "Ignorer la casse",
        "text_type": "Remplacement dans la traduction",
        "text_type_original": "Original",
        "text_type_translation": "Traduction",
        "keep_case": "Essayer de conserver la casse",
        "add": "Ajouter"
      },
      "content_exclusion": {
        "title": "Appliquer au contenu html",
        "description": "Sélectionnez un ou plus de selecteurs CSS que vous voulez éviter de traduire",
        "label": "Sélecteur CSS",
        "placeholder": "Sélecteur CSS",
        "add": "Ajouter"
      },
      "multilingual_url": {
        "title": "Utilisation des URLs multilingue",
        "description": "Si Oui, l'URL ne sera pas traduite mais la page sera toujours multilingue, et son contenu sera traduit",
        "live_example_title": "Example en direct",
        "live_example_description": "URL source: https://yourwebsite.com/page-non-traduite",
        "live_example_multilingual": "URL générée: https://yourwebsite.com/de/page-non-traduite",
        "live_example_no_multilingual": "Generated url: https://yourwebsite.com/page-non-traduite"
      },
      "rule_application": {
        "description": "Appliquer la règle sur le contenu statique ou le contenu dynamique ou les deux",
        "title": "S'appliquer au contenu",
        "all": "Tout contenu",
        "static": "Contenu statique",
        "dynamic": "Contenu dynamique"
      },
      "force_apply_urls": {
        "title_description": "Force Appliquez cette règle à toutes les traductions des URL, y compris les traductions existantes!",
        "title_replace": "Force remplacer dans les URL",
        "title_exclude": "Force exclue dans les URL",
        "warning": "Avertissement",
        "warning_part1": "La définition de ceci sur \"Oui\" peut briser les traductions de l'URL de votre site Web.",
        "warning_part2": "Cela peut générer temporairement ou de façon permanente une page 404S, veuillez ne continuer que si vous comprenez les conséquences.",
        "warning_replacement_original": "Avertissement supplémentaire: vous essayez de remplacer le contenu original qui pourrait affecter l'URL, la traduction peut échouer car Linguise incapable de trouver correctement les URL d'origine"
      }
    },
    "main": {
      "parent": "Règles",
      "edit": "Edition de règle",
      "add": "Nouvelle règle"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\"  sera ignoré dans le contenu et les URLs",
      "preview_single": "\"{{text_ignore}}\" sera ignoré dans le contenu",
      "preview_more_with_url": "\"{{text_ignore}}\" et {{count}} de plus seront ignorés dans le contenu et les URLs",
      "preview_more": "\"{{text_ignore}}\" et {{count}} de plus seront ignorés dans le contenu",
      "other_parameters": "D'autres paramètres sont enregistrés pour cette règle, cliquez sur le bouton d'édition pour plus d'informations"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" est remplacé par \"{{replacement}}\" dans le contenu et URLs",
      "preview_single": "\"{{original}}\" est remplacé par \"{{replacement}}\" dans le contenu",
      "preview_more_with_url": "\"{{original}}\" est remplacé par \"{{replacement}}\" dans le contenu et URLs, et {{nb}} de plus",
      "preview_more": "\"{{original}}\" est remplacé par \"{{replacement}}\" dans le contenu, et {{nb}} de plus",
      "other_parameters": "D'autres paramètres sont enregistrés pour cette règle, cliquez sur le bouton d'édition pour plus d'informations"
    },
    "content_exclusion": {
      "selectors": "{{nb}} selecteur(s) CSS sont exclus de la traduction",
      "other_parameters": "D'autres paramètres sont enregistrés pour cette règle, cliquez sur le bouton d'édition pour plus d'informations"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URLs sont non traduites, mais gardent le préfix de langue",
      "some": "{{nb}} URLs sont entièrement non traduites",
      "all_multilingual": "Toutes les URLs sont entièrement non traduites, mais gardent le préfix de langue",
      "all": "Toutes les URLs sont entièrement non traduites",
      "other_parameters": "D'autres paramètres sont enregistrés pour cette règle, cliquez sur le bouton d'édition pour plus d'informations"
    },
    "ignore_inline": {
      "elements": "Tout le contenu en ligne sera traduit en tant que blocs dans la page",
      "all_elements": "Certains contenus en ligne sont traduits en blocs dans le contenu dans la page",
      "other_parameters": "D'autres paramètres sont définis pour cette règle ; cliquez sur le bouton Modifier pour obtenir plus d'informations."
    },
    "title": "Gestion des règles",
    "description": "Gérez vos règles de traduction, de remplacement, d'exclusion de contenu",
    "add": "Ajouter une règle",
    "table": {
      "title": "Titre",
      "type": "Type",
      "preview": "Description",
      "action": "Actions",
      "delete_confirm": "Veuillez confirmer la suppression de la règle",
      "types": {
        "text_ignore": "Ignore un texte",
        "text_replace": "Remplacer un text",
        "content_exclusion": "Exclusion de contenu",
        "url_exclusion": "Exclusion d'URL",
        "ignore_inline": "Ignore le contenu en ligne",
        "unknown": "Règle inconnue"
      },
      "no_data": "Pas de règles ici pour l'instant"
    },
    "apply_on_content": {
      "static": "Cette règle ne s'appliquera qu'au contenu statique.",
      "dynamic": "Cette règle ne s'appliquera qu'au contenu dynamique."
    }
  },
  "search_translations": {
    "title": "Gestion des traduction des recherches",
    "description": "Liste toutes les traduction éffectuées sur votre site à partir des formualires de recherche (Depuis la langue traduite vers votre langue de base du domaine)",
    "filter_languages": "Filtrer par langue...",
    "filter_original": "Filtrer par texte en langue originale",
    "filter_translation": "Filtrer par traduction",
    "table": {
      "original": "Original",
      "language": "Langue",
      "translation": "Traduction"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "Échec de l'abonnement !",
      "title": "Échec de l'abonnement !",
      "subtitle": "Une erreur s'est produite lors de la tentative de traitement de votre abonnement.",
      "home": "Rentre à la maison",
      "generic": "Une erreur inconnue s'est produite du côté de Linguise, veuillez contacter l'administrateur !"
    },
    "success": {
      "home": "Gérer les traductions de domaine",
      "message": "Nous nous engageons à vous offrir la meilleure expérience de traduction possible. Notre équipe d’experts est disponible pour vous aider pour toute question ou assistance dont vous pourriez avoir besoin. Pour commencer, cliquez simplement sur le bouton ci-dessous.",
      "subtitle": "Merci d'avoir choisi le service de traduction Linguise",
      "title": "Abonnement activé !",
      "tab_title": "Merci pour votre abonnement !"
    }
  },
  "subscriptions": {
    "edit": {
      "title": "Gérer les souscriptions"
    },
    "list": {
      "title": "Liste des souscriptions",
      "description": "Liste des souscriptions liées au domaine"
    },
    "table": {
      "domain": "Domaine",
      "plan": "Souscriptions",
      "status": "Statut",
      "card": "Carte",
      "usage": "Usage",
      "actions": "Actions",
      "payment_method": "Mode de paiement"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} mots",
      "paidOffered": "{{words_used}} / {{words_allowed}} mots\n(Inclus {{free_words}} mots proposés)"
    },
    "success": {
      "tab_title": "Abonnement activé !",
      "title": "Abonnement activé !",
      "subtitle": "Merci d'avoir choisi le service de traduction Linguise",
      "message": "« Nous nous engageons à vous offrir la meilleure expérience de traduction possible. Notre équipe d’experts est disponible pour vous aider pour toute question ou assistance dont vous pourriez avoir besoin. Pour commencer, cliquez simplement sur le bouton ci-dessous.",
      "home": "Gérer les traductions de domaine"
    },
    "popup": {
      "dueToday": "Total dû aujourd'hui",
      "nextPeriod": "À partir du {{date}}"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "Choisissez un compte"
    }
  },
  "translation": {
    "main": {
      "parent": "Traduction",
      "edit": "Edition d'une traduction"
    },
    "form": {
      "original": {
        "title": "Original en {{language}}"
      },
      "is_inline": "Cette traduction est réalisée à partir du contenu en ligne.",
      "inline_editor": {
        "count_warning": "Le nombre de zones intégrées ne correspond pas à l’original ({{current}} sur {{expected}}).",
        "restore_original": "Rétablir le texte d’origine",
        "insert_placeholder": "Insérer un espace réservé",
        "drag": "Faire glisser pour réorganiser la zone",
        "area": "Zone en ligne {{index}}",
        "restore": "Rétablir les zones intégrées manquantes"
      },
      "translation": {
        "title": "Traduction en {{language}}",
        "description": "Traduction que vous voulez surcharger"
      }
    },
    "copy": {
      "title": "Copier dans la traduction manuelle",
      "label": "Copier en manuel"
    },
    "level": {
      "base": {
        "title": "Traduction de base",
        "subtitle": "Automatique · traduction Linguise Cloud",
        "empty": "Aucune traduction de base pour ce texte.",
        "overridden": "Votre choix est enregistré, mais la traduction améliorée par l'IA la plus récente est affichée à la place car « Remplacer les traductions manuelles et sélectionnées » est sur Oui dans la configuration de la traduction IA. Désactivez ce réglage pour utiliser votre choix."
      },
      "not_generated": "Non générée",
      "none": "Rien pour l'instant",
      "ai": {
        "title": "Traduction améliorée par l'IA",
        "subtitle": "Automatique · Linguise AI",
        "empty_title": "Pas encore générée pour ce texte",
        "empty_description": "Linguise AI produit des traductions plus naturelles en s'appuyant sur le contexte de votre page et de votre site. Pour en obtenir une ici :",
        "empty_step_1": "Allez dans Traduction IA › Configuration et réglez Activer la traduction IA sur « Règles uniquement », « Éditeur en direct uniquement » ou « Règles et éditeur en direct ».",
        "empty_step_2": "Appliquez-la avec une règle correspondant à cette page, ou activez-la page par page depuis l'éditeur en direct.",
        "empty_step_3": "La traduction améliorée par l'IA apparaîtra ici une fois générée. Elle utilise vos crédits IA.",
        "open_settings": "Ouvrir la configuration de la traduction IA",
        "open_editor": "Ouvrir l'éditeur en direct",
        "overrides_selection": "Votre choix est enregistré, mais cette traduction améliorée par l'IA est affichée à la place car « Remplacer les traductions manuelles et sélectionnées » est sur Oui dans la configuration de la traduction IA. Désactivez ce réglage pour utiliser votre choix.",
        "overrides_version": "La version que vous avez choisie est enregistrée, mais la version améliorée par l'IA la plus récente est affichée à la place car « Remplacer les traductions manuelles et sélectionnées » est sur Oui dans la configuration de la traduction IA. Désactivez ce réglage pour utiliser la version choisie."
      },
      "manual": {
        "title": "Traduction manuelle",
        "subtitle": "Rédigée par vous · prioritaire sur les traductions automatiques",
        "empty": "Vide",
        "saved_but_overridden": "Enregistrée comme votre choix, mais non affichée automatiquement car « Remplacer les traductions manuelles » est sur Oui dans la configuration de la traduction IA : la traduction améliorée par l'IA l'emporte tant que ce réglage n'est pas désactivé.",
        "ignored": "Non affichée automatiquement car « Remplacer les traductions manuelles » est sur Oui dans la configuration de la traduction IA. Sélectionnez-la pour l'utiliser pour ce texte.",
        "label": "Votre traduction",
        "placeholder": "Saisissez votre propre traduction...",
        "last_updated": "Dernière modification : {{date}}",
        "save_hint": "L'enregistrement d'une traduction manuelle l'active.",
        "delete": "Supprimer la traduction manuelle",
        "delete_confirm": "Veuillez confirmer la suppression de la traduction manuelle"
      }
    },
    "history": {
      "title": "Versions améliorées par l'IA",
      "subtitle": "Chaque régénération depuis l'éditeur en direct est conservée",
      "unknown_model": "Modèle inconnu",
      "current": "Actuelle",
      "restore": "Restaurer cette version",
      "restore_note": "La restauration fait de cette version la traduction améliorée par l'IA actuelle. Rien n'est supprimé.",
      "version_of": "Version {{current}} sur {{total}}",
      "hide": "Masquer l'historique ({{total}})",
      "show": "Afficher l'historique ({{total}})"
    },
    "choose": {
      "title": "Traductions en {{language}} · choisissez celle que voient les visiteurs",
      "current": "Actuellement sur votre site :",
      "priority": "Priorité par défaut : manuelle › améliorée par l'IA › de base. Votre choix n'est enregistré que pour cette traduction.",
      "reset": "Rétablir la priorité par défaut",
      "reset_title": "Oublier votre choix pour ce texte et réutiliser la priorité par défaut",
      "resetting": "Rétablissement ..."
    }
  },
  "translations": {
    "title": "Gestion des traduction",
    "description": "Liste de toutes les traduction effectuées sur votre site (avancé)",
    "filter_languages": "Filtrer par langue...",
    "filter_original": "Filtrer par texte en langue originale",
    "filter_translation": "Filtrer par traduction",
    "table": {
      "original": "Original",
      "language": "Langue",
      "action": "Action",
      "base": "Base",
      "ai": "Améliorée IA",
      "manual": "Manuelle"
    },
    "filter_exact": "Match exact",
    "badge": {
      "active": "Active",
      "overrides_manual": "Remplace le manuel"
    },
    "cell": {
      "none": "aucune",
      "not_generated": "non générée",
      "ignored": "Ignorée – la règle IA l'emporte"
    },
    "tabs": {
      "all": "Toutes",
      "manual": "Avec manuelle",
      "ai": "Avec IA améliorée",
      "base": "Base seule"
    },
    "levels_hint": "Chaque texte a jusqu'à 3 niveaux — celui marqué Active est celui que voient les visiteurs."
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "Edition traduction d'URL"
    },
    "form": {
      "original": {
        "title": "Original en {{language}}"
      },
      "translation": {
        "title": "Traduction de l'URL en {{language}}",
        "description": "URL que vous souhaitez remplacer",
        "placeholder": "URL",
        "invalid_full": "Vous essayez de modifier avec un format incorrect, vous devez uniquement modifier les slugs/chemin d'accès de la traduction de l'URL.",
        "invalid": "URL/chemin d'accès fourni non valide"
      }
    }
  },
  "urls": {
    "title": "Edition des URLs",
    "description": "Liste des URLs de votre site (avancé, attention aux erreurs 404)",
    "filter_languages": "Filtrer par langue...",
    "filter_original": "Filtrer par URL en langue originale",
    "filter_translation": "Filtrer par traduction",
    "table": {
      "original": "URL Originale",
      "language": "Langue",
      "url": "URL Traduite",
      "action": "Action",
      "edited": "La traduction originale a été éditée"
    }
  }
}
